<template>
  <v-container>
    <v-card class="card-container">
      <v-tabs v-model="tab" color="deep-purple-accent-4" align-tabs="center">
        <v-tab value="one">Import From Url</v-tab>
        <v-tab value="two">Import From Excel</v-tab>
        <v-tab value="three">Rest Users</v-tab>
        <v-tab value="four">Smart Life</v-tab>
      </v-tabs>

      <!-- <v-card-text> -->
      <v-window v-model="tab" class="window-container">
        <v-window-item value="one">
          <v-btn @click="importUsersFromUrlHandler"> import </v-btn>
          <div>
            Number of users: {{ importApiStatus.totalNumbers }},
            <!-- <template> -->
            <div>
              <span>existedCount</span>
              <v-progress-linear
                v-model="importApiStatus.existedCount"
                :max="importApiStatus.totalNumbers"
                color="blue-grey"
                height="25"
              >
                <!-- <template v-slot:default="{ value }"> -->
                <strong>{{
                  importApiStatus.existedCount ? importApiStatus.existedCount : 0
                }}</strong>
                <!-- </template> -->
              </v-progress-linear>

              <br />
              <span>createdCount:</span>

              <v-progress-linear
                v-model="importApiStatus.createdCount"
                :max="importApiStatus.totalNumbers"
                color="blue-grey"
                height="25"
              >
                <!-- <template v-slot:default="{ value }"> -->
                <strong>{{
                  importApiStatus.createdCount ? importApiStatus.createdCount : 0
                }}</strong>

                <!-- </template> -->
              </v-progress-linear>
              <br />
            </div>
            <!-- </template> -->
          </div>
        </v-window-item>

        <v-window-item value="two">
          <v-file-input
            @change="onChange"
            @click:clear="onClear"
            show-size
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            label="File input"
          ></v-file-input>

          <div>
            Number of users: {{ fileInfo.usersNumber }},
            <!-- <template> -->
            <div>
              <span>existedCount</span>
              <v-progress-linear
                v-model="importExcelStatus.existedCount"
                :max="fileInfo.usersNumber"
                color="blue-grey"
                height="25"
              >
                <!-- <template v-slot:default="{ value }"> -->
                <strong>{{
                  importExcelStatus.existedCount ? importExcelStatus.existedCount : 0
                }}</strong>
                <!-- </template> -->
              </v-progress-linear>

              <br />
              <span>createdCount:</span>

              <v-progress-linear
                v-model="importExcelStatus.createdCount"
                :max="fileInfo.usersNumber"
                color="blue-grey"
                height="25"
              >
                <!-- <template v-slot:default="{ value }"> -->
                <strong>{{
                  importExcelStatus.createdCount ? importExcelStatus.createdCount : 0
                }}</strong>

                <!-- </template> -->
              </v-progress-linear>
              <br />
            </div>
            <!-- </template> -->
          </div>

          <v-btn @click="importUsersFromExcelHandler" :disabled="excelData.length == 0">
            import
          </v-btn>
        </v-window-item>

        <v-window-item value="three">
          <h2>Reset Users [ {{ userFrom }} ]</h2>
          <v-row>
            <v-col cols="8">
              <v-select
                clearable
                chips
                label="Users Added From"
                :items="usersFrom"
                v-model="userFrom"
              ></v-select>
            </v-col>
            <v-col cols="3">
              <v-dialog v-model="dialog" persistent width="auto">
                <template v-slot:activator="{ props }">
                  <v-btn
                    color="primary"
                    v-bind="props"
                    style="width: fit-content"
                    :disabled="userFrom == null"
                  >
                    Reset
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title class="text-h5">
                    Are you sure you want to reset {{ userFrom }} users ?
                  </v-card-title>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green-darken-1" variant="text" @click="dialog = false">
                      No
                    </v-btn>
                    <v-btn color="green-darken-1" variant="text" @click="confirmHandler">
                      Yes
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
        </v-window-item>

        <v-window-item value="four">
          <div class="d-flex align-center gap-3 mb-4">
            <v-btn
              color="primary"
              :loading="isSmartLifeSyncing"
              @click="importUsersFromSmartLifeHandler"
              prepend-icon="mdi-sync"
            >
              مزامنة العملاء من سمارت لايف
            </v-btn>
            <v-btn
              class="mx-2"
              variant="outlined"
              @click="fetchSmartLifeUsers"
              prepend-icon="mdi-refresh"
              :loading="isLoadingSmartLifeUsers"
            >
              تحديث القائمة
            </v-btn>
          </div>

          <div class="mb-4">
            <p><strong>إجمالي العملاء المستلمين من سمارت لايف:</strong> {{ importSmartLifeStatus.totalNumbers }}</p>
            <p><strong>العملاء الصالحين للمزامنة:</strong> {{ importSmartLifeStatus.validNumbers }}</p>
            <div>
              <span>العملاء المسجلين مسبقاً (existedCount): {{ importSmartLifeStatus.existedCount }}</span>
              <v-progress-linear
                :model-value="importSmartLifeStatus.existedCount"
                :max="importSmartLifeStatus.validNumbers || 1"
                color="blue-grey"
                height="20"
                class="mb-2"
              ></v-progress-linear>

              <span>العملاء الجدد المضافين (createdCount): {{ importSmartLifeStatus.createdCount }}</span>
              <v-progress-linear
                :model-value="importSmartLifeStatus.createdCount"
                :max="importSmartLifeStatus.validNumbers || 1"
                color="success"
                height="20"
              ></v-progress-linear>
            </div>
          </div>

          <v-divider class="my-4"></v-divider>

          <div>
            <div class="d-flex justify-space-between align-center mb-3">
              <h3>قائمة عملاء سمارت لايف ({{ smartLifeUsers.length }})</h3>
              <v-text-field
                v-model="smartLifeSearch"
                density="compact"
                placeholder="بحث بالاسم أو الرقم..."
                append-inner-icon="mdi-magnify"
                variant="outlined"
                hide-details
                style="max-width: 300px"
              ></v-text-field>
            </div>

            <v-table density="compact" height="350px" fixed-header>
              <thead>
                <tr>
                  <th class="text-left">#</th>
                  <th class="text-left">الاسم (Name)</th>
                  <th class="text-left">رقم الهاتف (Phone)</th>
                  <th class="text-left">المصدر (Added From)</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(u, index) in filteredSmartLifeUsers" :key="u.id || index">
                  <td>{{ index + 1 }}</td>
                  <td>{{ u.name }}</td>
                  <td>{{ u.phone_number || '-' }}</td>
                  <td>
                    <v-chip size="small" color="teal">{{ u.added_from || 'smart_live' }}</v-chip>
                  </td>
                </tr>
                <tr v-if="filteredSmartLifeUsers.length === 0">
                  <td colspan="4" class="text-center py-4 text-grey">
                    {{ isLoadingSmartLifeUsers ? 'جاري التحميل...' : 'لا يوجد عملاء من سمارت لايف حالياً' }}
                  </td>
                </tr>
              </tbody>
            </v-table>
          </div>
        </v-window-item>
      </v-window>
      <!-- </v-card-text> -->
    </v-card>
  </v-container>
</template>

<style scoped>
.card-container {
  box-shadow: none;
  height: 80vh;
}
.window-container {
  padding: 20px;
}
</style>

<script>
import repository from '../../api/repository'

import * as XLSX from 'xlsx'
import { mapState, mapActions } from 'pinia'
import { useGlobalStore } from '../../stores/global'
import { useUserStore } from '../../stores/user'

export default {
  name: 'UsersSettingView',
  components: {},

  data: () => ({
    tab: null,
    dialog: false,
    usersFrom: ['all', 'excel_sheet', 'url', 'api', 'conversation', 'smart_live'],
    importSmartLifeStatus: {
      existedCount: 0,
      createdCount: 0,
      totalNumbers: 0,
      validNumbers: 0,
    },
    isSmartLifeSyncing: false,
    isLoadingSmartLifeUsers: false,
    smartLifeUsers: [],
    smartLifeSearch: '',
    userFrom: null,
    responseMsgs: [],
    file: null,
    fileInfo: {
      size: 0,
      usersNumber: 0,
    },
    importExcelStatus: {
      existedCount: 0,
      createdCount: 0,
    },
    importUrlStatus: {
      existedCount: 0,
      createdCount: 0,
      totalNumbers: 0,
    },

     importApiStatus: {
      existedCount: 0,
      createdCount: 0,
      totalNumbers: 0,
    },
    excelData: [],
  }),
  computed: {
    ...mapState(useGlobalStore, ['notifications']),
    filteredSmartLifeUsers() {
      if (!this.smartLifeSearch) return this.smartLifeUsers;
      const s = this.smartLifeSearch.toLowerCase();
      return this.smartLifeUsers.filter(u =>
        (u.name && u.name.toLowerCase().includes(s)) ||
        (u.phone_number && String(u.phone_number).includes(s))
      );
    },
  },
  methods: {
    ...mapActions(useGlobalStore, ['setNotify', 'setAlertMessage', 'setNotifications', 'appendNotifications']),
    ...mapActions(useUserStore, ['setIsUsersUpdated']),

    async importUsersFromSmartLifeHandler() {
      try {
        this.isSmartLifeSyncing = true;
        const res = await repository.importSmartLife();
        this.setAlertMessage({
          display: true,
          text: "بدأ استيراد عملاء سمارت لايف في الخلفية (Job)",
          class: "info",
        });
        if (res.data?.messages) {
          this.appendNotifications(res.data.messages);
        }
        this.setNotify();
      } catch (err) {
        this.setAlertMessage({
          display: true,
          text: err.response?.data?.message || "حدث خطأ أثناء بدء مزامنة سمارت لايف",
          class: "error",
        });
        this.setNotify();
      } finally {
        this.isSmartLifeSyncing = false;
      }
    },

    async fetchSmartLifeUsers() {
      try {
        this.isLoadingSmartLifeUsers = true;
        const res = await repository.addedFrom('smart_live');
        this.smartLifeUsers = res.data?.data || [];
      } catch (err) {
        console.error("Error fetching smart_live users", err);
      } finally {
        this.isLoadingSmartLifeUsers = false;
      }
    },

    async importUsersFromUrlHandler() {
      const usersUrl = process.env.VUE_APP_USERS_API;
      const res = await repository.create('users/import-url', {
        url: `${usersUrl}`,
      })
      console.log({
        res
      })
      this.setNotifications(res.data.messages)
      // this.importUrlStatus.existedCount += res?.data?.existedCount
      // this.importUrlStatus.createdCount += res?.data?.createdCount
      this.setAlertMessage( {
          display: true,
          text: res.data.messages[0],
          class: "success",
        })
      // if (this.importUrlStatus.createdCount > 0) {
      //   this.setIsUsersUpdated()
      // }
      this.setNotify()

      console.log({
        res,
      })
    },

    async importUsersFromExcelHandler() {
      const chunkSize = 100
      for (let idx = 0; idx < this.excelData.length; idx += chunkSize) {
        const chunk = this.excelData.slice(idx, idx + chunkSize)
        console.log({
          chunk,
          idx,
          t: idx === 0,
        })

        const res = await repository.create('users/import', { data: chunk })

        // this.responseMsgs.push(...res.data.data)

        // await this.$store.dispatch('SET_LOGGER', this.responseMsgs)
        if (idx === 0) {
          console.log('setNotifications')
          this.setNotifications(res.data.data.messages)
        } else {
          console.log('appendNotifications')

          this.appendNotifications(res.data.data.messages)
        }
        this.importExcelStatus.existedCount += res.data.data.existedCount
        this.importExcelStatus.createdCount += res.data.data.createdCount

        if (this.importExcelStatus.createdCount > 0) {
          this.setIsUsersUpdated()
        }

        this.setNotify()

        console.log({
          res,
        })
      }
    },
    onClear() {
      console.log('onClear')
      this.fileInfo.usersNumber = 0
      this.excelData = []
    },
    async onChange(event) {
      this.file = event.target.files ? event.target.files[0] : null
      if (this.file) {
        console.log({
          wb: this.file,
        })
        this.fileInfo.size = this.file.size
        const reader = new FileReader()

        reader.onload = async (e) => {
          /* Parse data */
          const bstr = e.target.result
          const wb = XLSX.read(bstr, { type: 'binary' })
          /* Get first worksheet */
          const wsname = wb.SheetNames[0]
          const ws = wb.Sheets[wsname]
          /* Convert array of arrays */
          this.excelData = XLSX.utils.sheet_to_json(ws, { header: 1 })
          this.excelData.shift()
          console.log({
            data: this.excelData,
            wb: this.file,
          })

          this.excelData.forEach((item) => {
            console.log({ is0: item[0] !== undefined, is1: item[1] !== undefined })
          })
          this.excelData = this.excelData.filter((item) => {
            return item[0] !== undefined && item[1] !== undefined
          })
          this.fileInfo.usersNumber = this.excelData.length
        }
        reader.readAsBinaryString(this.file)
        this.file = null
      }
    },
    async confirmHandler() {
      this.dialog = false
      if (this.userFrom) {
        const res = await repository.create('users/reset', { added_from: this.userFrom })
        // this.responseMsgs.push(res.data.data)
        // await this.$store.dispatch('SET_LOGGER', this.responseMsgs)
        this.setNotifications([res.data.data])
        this.setIsUsersUpdated()
        console.log({ res })
        this.setNotify()
      }
    },
  },

  async updated() {},
  async created() {
    console.log('users | created')
  },
  async mounted() {
    console.log('users')
        const baseUrl = process.env.VUE_APP_BACK_END_BASE_URL


    // eslint-disable-next-line no-undef
    const socket = io.connect(`${baseUrl}`, {
      transports: ['websocket'], // specify WebSocket as the only transport method
    });



    socket.on('importURL', async (data) => {
      console.log("importURL", { data,totalNumbers: data.response.totalNumbers,  existedCount: data.response.existedCount, createdCount: data.response.createdCount })
        this.importApiStatus.totalNumbers += data.response.totalNumbers
          this.importApiStatus.existedCount += data.response.existedCount

          this.importApiStatus.createdCount += data.response.createdCount
      this.setAlertMessage( {
          display: true,
          text: "import users Done successfully",
          class: "success",
        })
          this.appendNotifications(data.response.messages)
          

        if (this.importApiStatus.createdCount > 0) {
          this.setIsUsersUpdated()
        }
    })

    await this.fetchSmartLifeUsers();

    socket.on('importSmartLife', async (data) => {
      console.log("importSmartLife socket event received", data);
      if (data && data.response) {
        this.importSmartLifeStatus.totalNumbers = data.response.totalNumbers || 0;
        this.importSmartLifeStatus.validNumbers = data.response.validNumbers || 0;
        this.importSmartLifeStatus.existedCount = data.response.existedCount || 0;
        this.importSmartLifeStatus.createdCount = data.response.createdCount || 0;

        this.setAlertMessage({
          display: true,
          text: `تمت مزامنة عملاء سمارت لايف بنجاح! تم إنشاء: ${data.response.createdCount}، وموجود مسبقاً: ${data.response.existedCount}`,
          class: "success",
        });
        if (data.response.messages) {
          this.appendNotifications(data.response.messages);
        }
        if (data.response.createdCount > 0) {
          this.setIsUsersUpdated();
        }
      }
      await this.fetchSmartLifeUsers();
    });

    socket.on('importSmartLifeError', (data) => {
      this.setAlertMessage({
        display: true,
        text: `خطأ في مزامنة سمارت لايف: ${data.error}`,
        class: "error",
      });
      this.setNotify();
    });
  },
}
</script>
